module.exports = __webpack_public_path__ + "static/media/members-bg.d250a956.jpg";